import { download as _download, generateCsv as _generateCsv, mkConfig } from "export-to-csv";

interface CreateCsv<T extends Record<string, unknown> = Record<string, unknown>> {
	items: T[];
	fileName: string;
	download: boolean;
}

const EMPTY_STRING = "# EMPTY";
const SKIP_STRING = "# SKIP";

export function generateCsv<T extends Record<string, unknown>>({
	items,
	fileName,
	download,
}: CreateCsv<T>) {
	/** Parsed */
	const _fileName = fileName.replaceAll(".csv", "").split(".").at(0);

	/** Config */
	const config = mkConfig({ filename: _fileName, useKeysAsHeaders: true });

	/** Flatten */
	const flatItems = items.map((item) => {
		const keys = Object.keys(item);
		const _item: Record<string, number | string> = {};
		for (const key of keys) {
			const value = item[key];
			if (typeof value === "string") {
				_item[key] = value;
			} else if (typeof value === "number") {
				_item[key] = value;
			} else if (typeof value === "boolean") {
				_item[key] = value ? "TRUE" : "FALSE";
			} else if (value instanceof Date) {
				_item[key] = value.toISOString();
			} else if (value === null) {
				_item[key] = EMPTY_STRING;
			} else if (typeof value === "object") {
				_item[key] = SKIP_STRING;
			} else {
				_item[key] = SKIP_STRING;
			}
		}
		return _item;
	}) as Array<Record<string, string | number>>;

	/** Generate CSV */
	const csv = _generateCsv(config)(flatItems);

	if (typeof window !== "undefined") {
		if (download) {
			_download(config)(csv);
		}
	}
	return csv;
}

export { _download as download };
